import React, { useState } from 'react'
import Hsnlist from './hsnlist';
import HsnById from './hsnById';

export default function Hsn() {

    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);
    const [listVersion, setListVersion] = useState();

    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    console.log("Active Record:", activeRecord);
    /* -------- SAVE / UPDATE HANDLER -------- */

    const handleSubmit = async (data, id) => {
        try {
            if (id) {
                console.log("Update API Call", id, data);
                // await updateHsn(id, data)
            } else {
                console.log("Create API Call", data);
                // await createHsn(data)
            }

            closeForm();
            setListVersion(Date.now()); // refresh list
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div className="card shadow-lg main-card">

            {/* ---------- HEADER ---------- */}
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "HSN Management"
                        : isCreating
                            ? "Create HSN"
                            : activeRecord?.mode === "edit"
                                ? "Edit HSN"
                                : "View HSN"}
                </h4>
            </div>

            {/* ---------- BREADCRUMBS ---------- */}
            {onlyFormVisible && (
                <nav className="px-3 py-2 border-bottom bg-light">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                HSN Management
                            </button>
                        </li>

                        <li className="breadcrumb-item active fw-semibold text-primary">
                            {isCreating
                                ? "Create HSN"
                                : activeRecord?.mode === "edit"
                                    ? "Edit HSN"
                                    : "View HSN"}
                        </li>
                    </ol>
                </nav>
            )}

            <div className="card-body">

                {!onlyFormVisible ? (

                    <Hsnlist
                        refreshKey={listVersion}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) =>
                            setActiveRecord({ mode: "view", data: row })
                        }
                        onEdit={(row) =>
                            setActiveRecord({ mode: "edit", data: row })
                        }
                    />

                ) : (

                    <HsnById
                        initialValues={activeRecord?.data}
                        isEdit={activeRecord?.mode === "edit"}
                        viewOnly={activeRecord?.mode === "view"}
                        onSubmit={handleSubmit}
                        onCancel={closeForm}
                    />

                )}

            </div>
        </div>
    )
}
